// extracted by mini-css-extract-plugin
export var center = "_16-2";
export var clickableRow = "_16-5";
export var expandedRow = "_16-7";
export var hoverable = "_16-4";
export var left = "_16-1";
export var right = "_16-3";
export var row = "_16-0";
export var selectedRow = "_16-6";
export var summaryRow = "_16-8";